import * as React from 'react';
import { useSelector } from 'react-redux';

import { StickyFooter } from '../../components/StickyFooter';
import { useTeaserTracking } from '../../hooks/useTeaserTracking';
import { selectIsStickyBtnVisible } from '../../selectors/selectIsStickyScrollBtnVisible';
import { GoToMyOffers } from '../GoToMyOffers';
import { ShareButtonContainer } from '../ShareButtonContainer';

interface IStickyFooterContainerProps {
  theme?: 'dark';
}

export const StickyFooterContainer: React.FC<IStickyFooterContainerProps> = ({ theme }) => {
  const isVisible = useSelector(selectIsStickyBtnVisible);
  const { trackShowStickyButton } = useTeaserTracking();

  React.useEffect(() => {
    if (isVisible) {
      trackShowStickyButton();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <StickyFooter theme={theme}>
      <ShareButtonContainer isEndPage />
      <GoToMyOffers />
    </StickyFooter>
  );
};

StickyFooterContainer.displayName = 'StickyFooterContainer';
